export const NOTICIA = 'NOTICIA';
export const MORE_NOTICIA = 'MORE_NOTICIA';
export const PAGINATE_NOTICIA = 'PAGINATE_NOTICIA';
export const INFORME_COMERCIAL = 'INFORME_COMERCIAL';
